import request from "@/api";
import { BaseService } from "@/api/services/baseService";
import type { ProductTypeIndex, ProductTypeIndexVo } from "@zhihaoscm/entity";
import type { Page, ProductTypeTopParams, ProductTypeTopVo } from "@zhihaoscm/entity";
import { confirmable } from "@/utils/decorator/confirmable";
import type {
    ProductParams,
    ProductTypeIndexForm,
    ProductTypeIndexQueryParam
} from "@/entity/indexResearch/productTypeIndex";

export class IndexService extends BaseService<
    ProductTypeIndex,
    ProductTypeIndexVo,
    ProductTypeIndexQueryParam,
    ProductTypeIndexForm
> {
    // 根据价格日期和品类查询列表数据
    public async getChildList(params: ProductParams): Promise<ProductTypeIndexVo[]> {
        const { data } = await this.service.get(`${this.path}/date/${params.date}/product-type-id/${params.id}`);
        return data;
    }

    // 批量更新
    public update<F>(form: F) {
        return this.service.put(this.path, form);
    }

    /** 置顶或取消置顶 */
    public top(id: number) {
        return this.service.post(`${this.path}/top/${id}`);
    }

    public async paging(params: ProductTypeIndexQueryParam): Promise<Page<ProductTypeIndexVo>> {
        const { data } = await this.service.get(`${this.path}/paging`, { params });
        return data;
    }

    @confirmable("是否删除，删除后该砂石指数将不再展示")
    public async deleteByDate(row: ProductTypeIndexVo) {
        return this.service.delete(
            `${this.path}/date/${row.productTypeIndex.date}/product-type-id/${row.productType.id}`
        );
    }

    /**修改状态 */
    @confirmable({
        msgs: ["是否撤回", "是否发布"],
        switchParamFiled: "state"
    })
    public async updateState(
        params: ProductParams & {
            state: number;
        }
    ) {
        return this.service.put(`${this.path}/date/${params.date}/product-type-id/${params.id}/state/${params.state}`);
    }

    /**
     * 通过品类id和查询模式查询价格分析数据
     * */
    public async priceAnalysis(params: {
        productTypeId: string;
        queryMode: number;
    }): Promise<Page<ProductTypeIndexVo>> {
        const { data } = await this.service.get(`${this.path}/price-analysis`, { params });
        return data;
    }

    public async topDetail(params: ProductTypeTopParams): Promise<Page<ProductTypeTopVo>> {
        const { data } = await this.service.get(`${this.path}/top-detail`, { params });
        return data;
    }
}

const indexService = new IndexService("/dataService/admin/product-type-index", request.service);

export default indexService;
